import type { SessionTenancy, TenantCompany, TenantProject } from "../shared/interfaces";

export interface BoundProject {
    company: TenantCompany;
    project: TenantProject;
}

/** The active project a session is bound to, with its active company. Membership lists
 * never choose a project; only the verified legacy binding or redirect hint does. */
export function sessionBoundProject(
    tenancy: SessionTenancy | null | undefined,
): BoundProject | null {
    const boundId = tenancy?.legacy_project_id ?? tenancy?.canonical_redirect_project_id;
    const project = tenancy?.projects.find((p) => p.project_id === boundId && p.state === "active");
    const company = tenancy?.companies.find(
        (c) => c.company_id === project?.company_id && c.state === "active",
    );
    return project && company ? { company, project } : null;
}

/** Whether a URL's `/{company}/{project}` selectors, as slugs or IDs, name the bound project. */
export function routeNamesBoundProject(
    route: { companySlug: string | null; projectSlug: string | null },
    bound: BoundProject,
): boolean {
    return (
        (route.companySlug === bound.company.slug ||
            route.companySlug === bound.company.company_id) &&
        (route.projectSlug === bound.project.slug || route.projectSlug === bound.project.project_id)
    );
}
